import {
    getData,
} from './Services'

export const getBanners = async () => {
    const res = await getData('/banners');
    return res
}
